import AppConstants from '../config/app.constants';

let RouteService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/route`, {
                params: {
                    "search": search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let filterRoutes = (filter) => {
        return $http
            .get(AppConstants.api + `/route`, {
                params: {
                    filter
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/route/create`, data)
            .then((res) => {
                return res.data
            })
    }

    let remove = (id, branchId) => {
        return $http
            .delete(AppConstants.api + `/route/${id}`, {
                params: {
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/route/${id}`, data)
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/route/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let sheet = (id, date, branch) => { // Example, ID=TR1, DATE=2017-01-01
        return $http
            .get(AppConstants.api + `/route/${id}/sheet?date=${date}&branch=${branch}`)
            .then((res) => {
                return res.data
            })
    }

    let getRouteSequence = (id, branch, day) => {
        return $http
            .get(AppConstants.api + `/route/${id}/sequence?day=${day}&branch=${branch}`)
            .then((res) => {
                return res.data
            })
    }

    let closeRoute = (branchId, id, date, windowId) => {
        return $http
            .post(AppConstants.api + `/route/${id}/close`, {
                branchId,
                date,
                windowId
            })
            .then((res) => {
                return res.data
            })
    }

    let coinPullReport = (id, date) => {
        return $http
            .get(AppConstants.api + `/route/${id}/coin-pull-report?date=${date}`)
            .then((res) => {
                return res.data
            })
    }

    let getUploadedFiles = () => {
        return $http
            .get(AppConstants.api + `/route/upload-files`)
            .then((res) => {
                return res.data
            })
    }

    let getUploadFile = (fileName, branchId) => {
        return $http
            .get(AppConstants.api + `/route/upload-file?file=${fileName}&branchId=${branchId}`)
            .then((res) => {
                return res.data
            })
    }

    let removeUploadFile = (fileName) => {
        return $http
            .post(AppConstants.api + `/route/delete-upload-file`, { fileName })
            .then((res) => {
                return res.data
            })
    }

    let unlockFile = (fileName) => {
        return $http
            .post(AppConstants.api + `/route/unlock-file`, { fileName })
            .then((res) => {
                return res.data
            })
    }

    let lockFile = (fileName) => {
        return $http
            .post(AppConstants.api + `/route/lock-file`, { fileName })
            .then((res) => {
                return res.data
            })
    }

    let releaseRoute = (route, date, branchId, routeReleaseFrom) => {
        return $http
            .post(AppConstants.api + `/route/release`, { route, date, branchId, routeReleaseFrom })
            .then((res) => {
                return res.data
            })
    };

    let releaseRoutes = (routes, date) => {
        return $http
            .post(AppConstants.api + `/route/release`, { routes, date })
            .then((res) => {
                return res.data
            })
    };

    let routeCheckout = (branchId, id, date, fromTanker, toTanker, window, messengerId, routeDetailConfigurationValue) => {
        return $http
            .post(AppConstants.api + `/route/${id}/checkout`, { branchId, date, fromTanker, toTanker, window, messengerId, routeDetailConfigurationValue })
            .then((res) => {
                return res.data
            })
    }

    let routeStatus = (routeId, vaultDate, branchId) => {
        return $http
            .get(AppConstants.api + `/route/route-status/${routeId}?vaultDate=${vaultDate}&branchId=${branchId}`)
            .then((res) => {
                return res.data
            })
    }

    let routeLocTransfer = (data) => {
        return $http
            .post(AppConstants.api + `/route/route-transfer`, data)
            .then((res) => {
                return res.data
            })
    }

    let getRouteSequenceCount = (id, branch, day) => {
        return $http
            .get(AppConstants.api + `/route/${id}/sequence-count?day=${day}&branch=${branch}`)
            .then((res) => {
                return res.data
            })
    }

    let getActiveRouteSequence = (id, branch, day) => {
        return $http
            .get(AppConstants.api + `/route/${id}/active-route-sequence?day=${day}&branch=${branch}`)
            .then((res) => {
                return res.data
            })
    }

    let exportCSV = (routeId, vaultDate, flag, timezone) => {
        return $http
            .get(AppConstants.api + `/route/export-route-csv/${routeId}?vaultDate=${vaultDate}&flag=${flag}&timezone=${encodeURIComponent(timezone)}`)
            .then((res) => {
                return res.data
            })
    }

    let routeStopList = (fromRouteId, toRouteId, date, branch) => {
        return $http
            .post(AppConstants.api + `/route/route-stop-list`, {
                fromRouteId,
                toRouteId,
                date,
                branch
            })
            .then((res) => {
                return res.data
            })
    }

    let routeStopTransferList = (fromRouteId, toRouteId, fromVaultDate, toVaultDate, branch) => {
        return $http
            .post(AppConstants.api + `/route/route-stop-transfer-list`, {
                fromRouteId,
                toRouteId,
                fromVaultDate,
                toVaultDate,
                branch
            })
            .then((res) => {
                return res.data
            })
    }

    let routeStopTransfered = (routes, branchId) => {
        return $http
            .post(AppConstants.api + `/route/route-stop-transfered`, {
                routes,
                branchId
            })
            .then((res) => {
                return res.data
            })
    }

    let updateStopsAndShipments = (transferredStops, stops, branchId, override, destinationRouteSequence) => {
        return $http
            .post(AppConstants.api + `/route/update-stops-and-shipments`, {
                transferredStops,
                stops,
                branchId,
                override,
                destinationRouteSequence
            })
            .then((res) => {
                return res.data
            })
    }

    let getAllBranchRoutes = (branch, date) => {
        return $http
            .post(AppConstants.api + `/route/get-all-branch-routes`, {
                branch,
                date
            })
            .then((res) => {
                return res.data;
            })
    }

    let getBranchRoutes = (branch, date) => {
        return $http
            .post(AppConstants.api + `/route/get-branch-routes`, {
                branch,
                date
            })
            .then((res) => {
                return res.data;
            })
    }

    let getActiveRoutes = (branchId, date) => {
        return $http
            .get(AppConstants.api + `/route/get-active-routes`, {
                params: {
                    branchId,
                    date
                }
            })
            .then((res) => {
                return res.data;
            })
    }

    let getRoutes = (branchId, vaultDate) => {
        return $http
            .post(AppConstants.api + `/route/get-routes`, {
                branchId,
                vaultDate
            })
            .then((res) => {
                return res.data;
            })
    }

    let getTankerAssignments = (routeId) => {
        return $http
            .get(AppConstants.api + `/route/${routeId}/tankers`)
            .then((res) => {
                return res.data
            })
    }

    let setTankerAssignments = (routeId, data) => {
        return $http
            .post(AppConstants.api + `/route/${routeId}/tankers`, data)
            .then((res) => {
                return res.data
            })
    }

    let getTankersAvailable = (routeId) => {
        return $http
            .get(AppConstants.api + `/route/${routeId}/tankers-available`)
            .then((res) => {
                return res.data
            })
    }

    let getRouteTanker = (routeId, routeDate) => {
        return $http
            .get(AppConstants.api + `/route/get-route-tanker/${routeId}?routeDate=${routeDate}`)
            .then((res) => {
                return res.data
            })
    }

    let getRouteUpdateHistory = (routeId, limit, offset) => {
        return $http
            .get(AppConstants.api + `/route/get-route-update-history/${routeId}?limit=${limit}&offset=${offset}`)
            .then((res) => {
                return res.data
            });
    }

    let saveRouteChanges = (routeId, assignedTankers, extraDetails, duration) => {
        return $http
            .post(AppConstants.api + `/route/save-route-changes`, {
                routeId,
                assignedTankers,
                extraDetails,
                duration
            })
            .then((res) => {
                return res.data
            })
    }

    let getPendingRouteChanges = (routeId) => {
        return $http
            .get(AppConstants.api + `/route/get-pending-route-changes/${routeId}`)
            .then((res) => {
                return res.data
            });
    }

    let removeRouteChanges = (jobId) => {
        return $http
            .post(AppConstants.api + `/route/remove-route-changes`, { jobId })
            .then((res) => {
                return res.data
            });
    }

    let sendDeliveryPickupReports = (routeId, vaultDate, timezone, sendDeliveryReports, sendPickupReports) => {
        return $http
            .post(AppConstants.api + `/route/${routeId}/send-delivery-pickup-reports`, {
                vaultDate, 
                timezone, 
                sendDeliveryReports, 
                sendPickupReports
            })
            .then((res) => {
                return res.data
            })
    }
    
    let branchCoinPullReport = (branch, vaultDate) => {
        return $http
            .get(AppConstants.api + `/route/branch-coin-pull-report`, {
                params: {
                    branch, vaultDate
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let exportAllRouteStops = (branchId, routeId, vaultDate, timezone) => {
        return new Promise(function (resolve, reject) {
            var url = AppConstants.api + `/route/export-all-route-stops`;
            var xhr = new XMLHttpRequest();
            var sheetName = "";

            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.responseType = "arraybuffer";

            var data = { branchId, routeId, vaultDate, timezone };

            xhr.onload = function () {
                if (this.status === 200) {
                    var blob = new Blob([xhr.response], { type: "application/xlsx" }),
                        a = document.createElement('a'),
                        reportPrefix = 'Route_Stops_',
                        dt = moment(vaultDate).format('DDMMYY');

                    sheetName = reportPrefix.concat(dt, '_', '(', branchId, ')', '.xlsx');
                    a.href = URL.createObjectURL(blob);
                    a.download = sheetName;
                    a.click();
                    resolve();
                }
                else reject();
            };

            return xhr.send(JSON.stringify(data));
        });
    }

    let getScheduledRouteByLocationId = (vaultDate, locationId, branchId = null) => {
      return $http
        .get(AppConstants.api + `/route/get-scheduled-routes-by-location`, {
          params: {
            vaultDate,
            locationId,
            branchId
          },
        })
        .then(res => {
          return res.data;
        });
    };

    let emailManifest = (routeId, data) => {
        return $http
            .post(AppConstants.api + `/route/${routeId}/email-manifest`, data)
            .then((res) => {
                return res.data;
            });
    };
    let pickupReportEmail = (emailData) => {
        return $http
            .post(AppConstants.api + `/route/pickup-report-email`, emailData)
            .then((res) => {
                return res.data
            })
    }

    let emailRouteSheet = (routeId, data) => {
        return $http
            .post(AppConstants.api + `/route/${routeId}/email-route-sheet`, data)
            .then((res) => {
                return res.data;
            });
    };
 
    let getAvailableRoutes = (branchId, vaultDate, offset, limit, searchKey, shuttleRoute) => {
        return $http
            .post(AppConstants.api + `/route/get-available-routes`, {
                branchId,
                vaultDate,
                offset,
                limit,
                searchKey,
                shuttleRoute
            })
            .then((res) => {
                return res.data;
            })
    }

    let validateLedgerBalanceAgainstRouteCoinHandler = (routeId, vaultDate) => {
        return $http
            .get(AppConstants.api + `/route/validate-ledger-balance-against-route-coin-handler`, { params: { routeId, vaultDate } })
            .then((res) => {
                return res.data
            });
    }

    return {
        all,
        create,
        remove,
        update,
        get,
        sheet,
        emailManifest,
        getRouteSequence,
        filterRoutes,
        closeRoute,
        coinPullReport,
        getUploadedFiles,
        getUploadFile,
        unlockFile,
        removeUploadFile,
        pickupReportEmail,
        lockFile,
        releaseRoute,
        releaseRoutes,
        routeCheckout,
        routeStatus,
        routeLocTransfer,
        getRouteSequenceCount,
        getActiveRouteSequence,
        exportCSV,
        routeStopList,
        routeStopTransferList,
        routeStopTransfered,
        updateStopsAndShipments,
        getAllBranchRoutes,
        getBranchRoutes,
        getActiveRoutes,
        getRoutes,
        getTankerAssignments,
        setTankerAssignments,
        getTankersAvailable,
        getRouteTanker,
        getRouteUpdateHistory,
        saveRouteChanges,
        getPendingRouteChanges,
        removeRouteChanges,
        sendDeliveryPickupReports,
        branchCoinPullReport,
        exportAllRouteStops,
        getScheduledRouteByLocationId,
        emailRouteSheet,
        getAvailableRoutes,
        validateLedgerBalanceAgainstRouteCoinHandler
    };
};

RouteService.$inject = ['$http', '$q']

export default RouteService;



// WEBPACK FOOTER //
// ./client/app/services/route.service.js